function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M480 181.44H53.333c-5.891 0-10.667-4.776-10.667-10.667s4.776-10.667 10.667-10.667H480c5.891 0 10.667 4.776 10.667 10.667S485.891 181.44 480 181.44zM437.333 330.773H10.667C4.776 330.773 0 325.998 0 320.106c0-5.891 4.776-10.667 10.667-10.667h426.667c5.891 0 10.667 4.776 10.667 10.667-.001 5.892-4.777 10.667-10.668 10.667z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M245.333 458.773c-5.891-.001-10.666-4.778-10.664-10.669 0-1.259.223-2.507.659-3.688L384.661 39.082c1.922-5.569 7.995-8.524 13.563-6.602 5.569 1.922 8.524 7.995 6.602 13.563-.049.141-.1.281-.155.42L255.339 451.797a10.668 10.668 0 01-10.006 6.976zM96 458.773c-5.891-.001-10.666-4.778-10.664-10.669 0-1.259.223-2.507.659-3.688L235.328 39.082c1.922-5.569 7.995-8.524 13.563-6.602 5.569 1.922 8.524 7.995 6.602 13.563-.049.141-.1.281-.155.42L106.005 451.797A10.665 10.665 0 0196 458.773z"
});

var SvgHashtag = function SvgHashtag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 490.667 490.667",
    fill: "#D6D7E1"
  }, props), _ref, _ref2);
};

export default SvgHashtag;